import React from 'react';
import Icon from '../Controls/Icon/Icon';
import { Icons } from '~/assets/fonts/Icons/icons';
import { localeStore } from '~/mobx/localesStore';
import { TRANSACTION_STATUSES } from '~/types/orders';

export const colorForTransactionByStatus = {
  [TRANSACTION_STATUSES.UNKNOWN]: '#FFD130',
  [TRANSACTION_STATUSES.SENT]: '#78B59F',
  [TRANSACTION_STATUSES.DONE]: '#78B59F',
  [TRANSACTION_STATUSES.FAILED]: '#FF7676',
};

export const REFUND_STATUSES_TXT = {
  [TRANSACTION_STATUSES.UNKNOWN]: 'refund_journal_refund_status_unknown',
  [TRANSACTION_STATUSES.SENT]: 'refund_journal_refund_status_sent',
  [TRANSACTION_STATUSES.DONE]: 'refund_journal_refund_status_done',
  [TRANSACTION_STATUSES.FAILED]: 'refund_journal_refund_status_failed',
};

export const getTransactionStatusTxt = (status: TRANSACTION_STATUSES) => {
  if (status === null) {
    return '-';
  }
  return localeStore.t(REFUND_STATUSES_TXT[status]);
};

// Define the prop type for the component
interface TransactionStatusProps {
  status: TRANSACTION_STATUSES;
}

// Use the prop type in the component
export const TransactionStatus: React.FC<TransactionStatusProps> = ({ status }) => {
  return (
    <>
      <Icon name={Icons.Circle} size={24} color={colorForTransactionByStatus[status]} />
      <p className="family-medium text-size-16 text-elipsis">{getTransactionStatusTxt(status)}</p>
    </>
  );
};
